
import { createReducer } from '@reduxjs/toolkit';

import {logoutAC} from 'model/system/systemActionCreators';
import { typeEncashHistoryState } from 'model/dashboardEncash/dEncashType';
import {
    dEncashClearFiltersAC,
    dEncashSetDataAC, dEncashSetDetailDataAC, dEncashSetFiltersAC,
    dEncashSetItemsForPageAC, dEncashSetPageNumberAC,
    dEncashSetPaginationAC, dEncashSetSortDirectionAC
} from 'model/dashboardEncash/dEncashActionCreators';


 const clearFilterObject ={
    date: null,
    store: null,
    user: null,
    terminalSn: null
}

// Init state
export const initialState: typeEncashHistoryState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailData: null,
    filters: clearFilterObject,
    sortDirection: 'DESC'
}


// Reducer
export const DEncashReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dEncashSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })

        // Reducer of set pagination
        .addCase(dEncashSetPaginationAC, (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload.pagination }
        })

        // Reducer of set items for page pagination
        .addCase(dEncashSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })

        // Reducer of set pageNumber pagination
        .addCase(dEncashSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dEncashSetDetailDataAC, (state, action) => {
            state.detailData = state.data.find((item) => item.id === action.payload) || null

        })


        // Reducer of clear filtersForm
        .addCase(dEncashClearFiltersAC, (state) => {
            state.filters = clearFilterObject
        })

        // Reducer of set filtersForm
        .addCase(dEncashSetFiltersAC, (state, action) => {
            state.filters = { ...state.filters, ...action.payload }
            state.pagination.pageNumber = 0

        })

        // Reducer of set sort Direction
        .addCase(dEncashSetSortDirectionAC, (state, action) => {
            state.sortDirection= action.payload
            state.pagination.pageNumber = 0
        })

        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailData=initialState.detailData
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

})

